import { ShieldX } from 'lucide-react';

interface Props {
  onLogout: () => void;
}

export default function SystemAccessDeniedScreen({ onLogout }: Props) {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center max-w-md px-6">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-100">
          <ShieldX className="h-7 w-7 text-red-600" />
        </div>
        <h1 className="text-xl font-bold text-gray-900 mb-2">Access Denied</h1>
        <p className="text-sm text-gray-600 mb-6">
          You do not have access to the Defensible system portal. This portal is restricted to
          authorized FireSquirrel platform administrators.
        </p>
        <p className="text-xs text-gray-400 mb-6">
          If you believe this is an error, contact your system administrator.
        </p>
        <button
          type="button"
          onClick={onLogout}
          className="px-4 py-2 rounded-lg text-sm font-medium text-white bg-slate-800 hover:bg-slate-700 transition-colors"
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}
